import { Box, Tooltip, useMediaQuery } from "@mui/material";
import { useLocation } from "react-router-dom";
import CustomNavLink from "../../atoms/navButton/main";
import { useSelector } from "react-redux";
import { stateType } from "../../../store/store.type";
import { useState } from "react";
const NavBar = () => {
  const location = useLocation();
  const panelOpen = useSelector((sel: stateType) => sel.panelSlice.panelOpen);
  const isSmallScreen = useMediaQuery("@media(max-width:600px)");
  const [open, setOpen] = useState(false);
  const [activeNav, setActiveNav] = useState("");

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    if (!panelOpen) setOpen(true);
  };
  return (
    <>
      <Tooltip
        placement="right"
        title="Overview"
        arrow
        open={open && activeNav === "summary"}
        onOpen={handleOpen}
        onClose={handleClose}
      >
        <Box
          sx={{
            backgroundColor:
              location.pathname.split("/")[1] === "summary"
                ? "rgba(0, 0, 0, 0.05)"
                : "white",
            height: "1.86rem",
            width: panelOpen || isSmallScreen ? "12.5rem" : "3.675rem",
            borderRadius: "8px",
            position: "relative",
          }}
          onMouseEnter={() => {
            if (!panelOpen) setActiveNav("summary");
          }}
          onMouseLeave={() => setActiveNav("")}
        >
          {location.pathname.split("/")[1] === "summary" && (
            <Box
              sx={{
                width: "5px",
                height: "22px",
                backgroundColor: "black",
                position: "absolute",
                borderRadius: "8px",
                top: "3px",
                left: panelOpen ? "2px" : "0px",
              }}
            ></Box>
          )}

          <CustomNavLink
            target="/summary"
            iconName="Overview"
            text="Overview"
            expanded={panelOpen || isSmallScreen}
          />
        </Box>
      </Tooltip>
      <Tooltip
        placement="right"
        title="Manage Farmers"
        arrow
        open={open && activeNav === "manage-farmers"}
        onOpen={handleOpen}
        onClose={handleClose}
      >
        <Box
          sx={{
            backgroundColor:
              location.pathname.split("/")[1] === "manage-farmers"
                ? "rgba(0, 0, 0, 0.05)"
                : "white",
            height: "1.86rem",
            width: panelOpen || isSmallScreen ? "12.5rem" : "3.675rem",
            borderRadius: "8px",
            position: "relative",
          }}
          onMouseEnter={() => {
            if (!panelOpen) setActiveNav("manage-farmers");
          }}
          onMouseLeave={() => setActiveNav("")}
        >
          {location.pathname.split("/")[1] === "manage-farmers" && (
            <Box
              sx={{
                width: "5px",
                height: "22px",
                backgroundColor: "black",
                position: "absolute",
                borderRadius: "8px",
                top: "2px",
                left: panelOpen ? "2px" : "0px",
              }}
            ></Box>
          )}
          <CustomNavLink
            target="/manage-farmers"
            iconName="farmerIcon"
            text="Manage Farmers"
            expanded={panelOpen || isSmallScreen}
          />
        </Box>
      </Tooltip>

      <Tooltip
        placement="right"
        title="Manage Surveyors"
        arrow
        open={open && activeNav === "manage-surveyors"}
        onOpen={handleOpen}
        onClose={handleClose}
      >
        <Box
          sx={{
            backgroundColor:
              location.pathname.split("/")[1] === "manage-surveyors"
                ? "rgba(0, 0, 0, 0.05)"
                : "white",
            height: "1.86rem",
            width: panelOpen || isSmallScreen ? "12.5rem" : "3.675rem",
            borderRadius: "8px",
            position: "relative",
          }}
          onMouseEnter={() => {
            if (!panelOpen) setActiveNav("manage-surveyors");
          }}
          onMouseLeave={() => setActiveNav("")}
        >
          {location.pathname.split("/")[1] === "manage-surveyors" && (
            <Box
              sx={{
                width: "5px",
                height: "22px",
                backgroundColor: "black",
                position: "absolute",
                borderRadius: "8px",
                top: "2px",
                left: panelOpen ? "2px" : "0px",
              }}
            ></Box>
          )}
          <CustomNavLink
            target="/manage-surveyors"
            iconName="Manage Survey Agents"
            text="Manage Surveyors"
            expanded={panelOpen || isSmallScreen}
          />
        </Box>
      </Tooltip>
      <Tooltip
        placement="right"
        title="Reports"
        arrow
        open={(open && activeNav) === "reports"}
        onOpen={handleOpen}
        onClose={handleClose}
      >
        <Box
          sx={{
            backgroundColor:
              location.pathname.split("/")[1] === "reports"
                ? "rgba(0, 0, 0, 0.05)"
                : "white",
            height: "1.86rem",
            width: panelOpen || isSmallScreen ? "12.5rem" : "3.675rem",
            borderRadius: "8px",
            position: "relative",
          }}
          onMouseEnter={() => {
            if (!panelOpen) setActiveNav("reports");
          }}
          onMouseLeave={() => setActiveNav("reports")}
        >
          {location.pathname.split("/")[1] === "reports" && (
            <Box
              sx={{
                width: "5px",
                height: "22px",
                backgroundColor: "black",
                position: "absolute",
                borderRadius: "8px",
                top: "2px",
                left: panelOpen ? "2px" : "0px",
              }}
            ></Box>
          )}
          <CustomNavLink
            target="/reports"
            iconName="Custom Reports"
            text="Custom Reports"
            expanded={panelOpen || isSmallScreen}
          />
        </Box>
      </Tooltip>
    </>
  );
};
export default NavBar;
